var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight2 = function SvgArrowRight2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m28.466 18-6.805-6.496-1.036 1.085 4.883 4.66H7.535v1.5h17.973l-4.883 4.662 1.036 1.085z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowRight2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzNiI+CiAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0ibTI4LjQ2NiAxOC02LjgwNS02LjQ5Ni0xLjAzNiAxLjA4NSA0Ljg4MyA0LjY2SDcuNTM1djEuNWgxNy45NzNsLTQuODgzIDQuNjYyIDEuMDM2IDEuMDg1TDI4LjQ2NiAxOFoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";